import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import FeedsSlider from "./FeedsSlider";
import { YOUTUBE_CHANNEL_URL } from "@/shared/utils/external/youtube/constants";

const YoutubeFeeds = ({ t }) => {
  const [players, setPlayers] = useState([]);
  const feeds = [
    { playerId: "embeddedvideoiframe1", listId: "PLqGlkhsuXZVeSJUwaLeGKs5V31DqogQD-" },
    { playerId: "embeddedvideoiframe2", listId: "PLqGlkhsuXZVf29YDczMEAWcuBZDg3WO-f" }
  ];

  const preloadScript = (id) => {
    if (document.getElementById(id)) {
      return;
    }

    const script = document.createElement("script");
    script.id = id;
    script.src = "//www.youtube.com/iframe_api";
    const firstScriptElement = document.getElementsByTagName("script")[0];
    firstScriptElement.parentNode.insertBefore(script, firstScriptElement);
  };

  const renderItem = ({ item }) => {
    const { playerId, listId } = item;

    return (
      <iframe
        id={playerId}
        src={`https://www.youtube.com/embed/videoseries?enablejsapi=1&list=${listId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen="allowfullscreen"
      />
    );
  };

  const onYouTubeIframeAPIReady = () => {
    const { YT } = window;

    if (YT && YT.loaded) {
      const playersArray = [];

      feeds.forEach(({ playerId, listId }) => {
        playersArray.push(new YT.Player(playerId, {
          height: "100%",
          width: "100%",
          videoId: listId,
          events: {
            "onStateChange": function (event) {
              if (event.data === YT.PlayerState.PLAYING) {
                playersArray.forEach((player) => {
                  if (
                    player.getPlayerState() === window.YT.PlayerState.PLAYING &&
                    player.getIframe().id !== event.target.getIframe().id
                  ) {
                    player.pauseVideo();
                  }
                });
              }
            }
          }
        }));
      });

      setPlayers(playersArray);
    }
  };

  useEffect(() => {
    preloadScript("youtube_iframe_api");
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    if (window.YT) {
      onYouTubeIframeAPIReady();
    }
  }, []);

  useEffect(() => {
    const destroyPlayers = (players) => {
      if (players.length > 0) {
        players.forEach((player) => {
          player.destroy();
        });
      }
    };

    return () => {
      destroyPlayers(players);
    };
  }, [players]);

  return (
    <FeedsSlider renderItem={renderItem} records={feeds} containerClassName="youtube-feeds">
      <h3 className="feeds-header">
        {t("follow_us_on")}
        <a
          href={YOUTUBE_CHANNEL_URL}
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          {t("youtube")}
        </a>
      </h3>
    </FeedsSlider>
  );
};

YoutubeFeeds.propTypes = {
  t: PropTypes.func.isRequired
};

export default YoutubeFeeds;
